var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"fluid-container footer bg-light"},[_c('b-row',{attrs:{"align-h":"center","align-v":"center"}},[_c('p',{staticClass:"mb-0"},[_vm._v("💻 with ❤ by @firtsguzman")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }